import { ArrowUpRight, FileText } from 'lucide-react'
import { referenceScenes } from '../bibleDiscovery'
import type { StoryProject } from '../types'

export function BibleSceneUses({
  project,
  targetId,
  onOpen,
}: {
  project: StoryProject
  targetId: string
  onOpen: (id: string) => void
}) {
  const scenes = referenceScenes(project, targetId)
  return (
    <section className="bible-scene-uses" aria-label="In the manuscript">
      <h3>
        <FileText size={16} /> In the manuscript{' '}
        <span>
          {scenes.length} {scenes.length === 1 ? 'scene' : 'scenes'}
        </span>
      </h3>
      <p>
        {targetId.startsWith('character:')
          ? 'Dialogue and linked mentions of this character, in scene order.'
          : 'Linked mentions of this entry, in scene order.'}{' '}
        Open a scene to keep writing.
      </p>
      <div className="bible-scene-list">
        {scenes.map((scene) => (
          <button
            type="button"
            key={scene.nodeId}
            onClick={() => onOpen('scene:' + scene.nodeId)}
            aria-label={
              'Open scene ' + scene.sceneNumber + ': ' + scene.title
            }
          >
            <span className="scene-use-number">
              {String(scene.sceneNumber).padStart(2, '0')}
            </span>
            <span>
              <strong>{scene.title || 'Untitled scene'}</strong>
              <small>
                {[
                  scene.chapter,
                  scene.dialogueLines
                    ? scene.dialogueLines +
                      (scene.dialogueLines === 1
                        ? ' dialogue line'
                        : ' dialogue lines')
                    : '',
                  scene.mentions
                    ? scene.mentions +
                      (scene.mentions === 1 ? ' mention' : ' mentions')
                    : '',
                  scene.planningMentions ? 'Planning notes' : '',
                ]
                  .filter(Boolean)
                  .join(' · ')}
              </small>
              {scene.excerpt && (
                <span className="scene-use-excerpt">{scene.excerpt}</span>
              )}
            </span>
            <ArrowUpRight size={15} aria-hidden="true" />
          </button>
        ))}
      </div>
      {!scenes.length && (
        <p className="empty-message">
          {targetId.startsWith('character:')
            ? 'Use this character as a dialogue speaker, or choose it from an @ suggestion while writing.'
            : 'Choose this entry from an @ suggestion in your draft or scene notes to find its scenes here.'}
        </p>
      )}
    </section>
  )
}
